import React from "react"
import "./src/meetYourTeam/assets/fonts/fonts.css"
import "./src/meetYourTeam/assets/css/global.css"

export const wrapRootElement = ({ element }) => {
  return <>{element}</>
}
